import { render, staticRenderFns } from "./RegistraVisita.vue?vue&type=template&id=6ce79384&scoped=true"
import script from "./RegistraVisita.vue?vue&type=script&lang=js"
export * from "./RegistraVisita.vue?vue&type=script&lang=js"
import style0 from "./RegistraVisita.vue?vue&type=style&index=0&id=6ce79384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce79384",
  null
  
)

export default component.exports